import ApiClient from './ApiClient'
import { withQuery } from '../../utils/urlParams'

const reportingBase = collectId => `/collects/${collectId}/reporting`

const issueStatusesParam = issueStatus => {
  if (!issueStatus || issueStatus === 'all')
    return null
  return [issueStatus]
}

class IssuesByStatusService {
  static getIssuesByStatus(collectId, options = {}) {
    const url = `${reportingBase(collectId)}/measures/issues_by_status.json`
    const params = [
      ['q', options.search],
      ['issue_statuses[]', issueStatusesParam(options.issueStatus)],
      ['draft_id', options.draftId],
      ['start_date', options.startDate],
      ['end_date', options.endDate]
    ]
    return ApiClient.get(withQuery(url, params))
  }
}

export default IssuesByStatusService
